import { IconButton } from "@fluentui/react";
import { ITheme, LineClampedText, themeUtils } from "cayo.ui";
import styled from "styled-components";
import { Row } from "@cayo/shared/components/CommonLayout";

export const ClearIconButton = styled(IconButton)<{ isMouseOver: boolean }>`
  margin-right: 4px;
  z-index: 1;
  visibility: ${(props) => (props.isMouseOver ? "visible" : "hidden")};
`;

export const StyledRow = styled(Row)`
  height: 100%;
`;

export const AnimationContainer = styled.div`
  height: 100%;
  flex-grow: 1;
  margin-left: 8px;
  width: 100%;
  display: flex;
  align-items: center;
`;

export const IconWrapper = styled(Row)`
  height: 100%;
  min-width: 42px;
  max-width: 42px;
  background-color: ${(props) =>
    themeUtils.addAlpha((props.theme as ITheme).cayoTheme.brandColors.disabled, 0.1)};
`;

export const AlertPopupTitle = styled(LineClampedText)<{ hasMessage: boolean }>`
  font-size: ${({ hasMessage }) => (hasMessage ? "12px" : "10px")};
  font-weight: ${({ hasMessage }) => (hasMessage ? 600 : "initial")};
  flex-grow: 1;
  max-height: 46px;
  max-width: 200px;
`;

export const AlertPopupDescription = styled(LineClampedText)`
  font-size: 10px;
`;
